if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
      this.redeemButton = this.querySelector('.circle-product-buttn_redeem');
      this.productredeemButton = this.querySelector('.circle-product-redeem_button');
      this.buttonPrice = this.querySelector('.js-button-price');
      this.variantOptions = {};
      this.cartAdded = document.querySelector('cart-added');
      this.quantity = this.querySelector('product-quantity input') || this.querySelector('product-quantity-animated input');
    }

    onSubmitHandler(evt) {
      evt.stopPropagation();
      evt.preventDefault();
  
      const masterSelect = this.querySelector('select');
      const quantity = this.quantity.value ? this.quantity.value : 1;

      this.submitButton.disabled = true;
      if(this.redeemButton){
        this.redeemButton.disabled = true;
      }
       if(this.productredeemButton){
        this.productredeemButton.disabled = true;
      }

      var cartItemSelector = document.querySelector('cart-item[data-id="'+masterSelect.value+'"]')
      var cartItemCounter = document.querySelector('.js-cart-count');
      var shippingUpdated = localStorage.getItem('shippingUpdated');
      
      var customPrice = this.submitButton.dataset.custom;
      var pointsAqu = this.submitButton.dataset.custompoints;
      var maxLimit = this.submitButton.dataset.maxlimit;
      if(cartItemSelector == null || cartItemSelector == undefined){
        var cartItemQty = 0
      }else{
        var cartItemQty = cartItemSelector.dataset.qty
      }
      var checkQty = parseInt(cartItemQty) + parseInt(quantity);

      if(checkQty > maxLimit ){
        this.submitButton.disabled = false;
        $('.cart-added:eq(0) .cart-added__title').html('You have reached the maximum order volume for this item. Please choose another item to continue shopping.');
        //$('.cart-added:eq(0) .cart-added__title+span').html("Earn More").css('text-decoration','underline');
        $('.cart-added:eq(0) .cart-added__title+span').html("").css('display','none');
        $('.cart-added:eq(0)').addClass('is-open');
        setTimeout(function(){
          $('.cart-added:eq(0)').removeClass('is-open');
        },3000)
        return false;
      }

      

      var shippingrate = $('cart-item[data-id="'+masterSelect.value+'"]').attr('data-shippingrate');
      var cartCount = document.querySelector('.js-cart-count').innerHTML;
// Iterate through all elements with class 'product_inner_wrapper' and extract the data-variant-id
var productIds = [];
var productNames = []; // Array to store data-variant-name values
var productPrices = [];
var productActuals = [];
var productPoints = [];
// Iterate through all elements with class 'product_inner_wrapper' and extract the data-variant-id and data-variant-name
var productWrappers = document.getElementsByClassName('product_inner_wrapper');

for (var i = 0; i < productWrappers.length; i++) {
  var productId = productWrappers[i].getAttribute('data-variant-id');
  var productName = productWrappers[i].getAttribute('data-variant-name'); // Get the data-variant-name
var productPrice = productWrappers[i].getAttribute('data-customprice');
 var productPoint = productWrappers[i].getAttribute('data-points');
var productActual = productWrappers[i].getAttribute('data-actualprice');

  if (productId !== null) {
    productIds.push(productId);
    productNames.push(productName);

var ActualPricee = parseInt(productActual.replace('.', ''), 10);
    productActuals.push(ActualPricee);

    var formattedPricee = parseInt(productPrice.replace('.', ''), 10);
    productPrices.push(formattedPricee);
productPoints.push(productPoint); // Push the data-variant-name to the array
  }
}

   var now = new Date();
var datehourandminuteandseconds = (now.getMonth() + 1).toString().padStart(2, '0') +
  now.getDate().toString().padStart(2, '0') +
  now.getHours().toString().padStart(2, '0') +
  now.getMinutes().toString().padStart(2, '0') +
  now.getSeconds().toString().padStart(2, '0');





      cartCount = parseInt(cartCount);
      


      if(customPrice != undefined){
        if(pointsAqu == undefined){
          if (productIds.length > 2) {
alert('A')
          }else if(cartCount === 0){
            var requestBody = { items: [{ id: masterSelect.value, quantity, properties: {"customprice":customPrice,'poi_code': poicode, 'shippingrate': 600} }] };
          }else{
            var requestBody = { items: [{ id: masterSelect.value, quantity, properties: {"customprice":customPrice,'poi_code': poicode} }] }; 
          }
        }else{

                    if (productIds.length > 0) {

          
  var requestBody = {
    items: productIds.map(function (productId, index) {
      return {
        id: productId,
        quantity,
        properties: {
          giftset: datehourandminuteandseconds,
          poi_code :poicode,
          actualprice : productActuals[index],
          customprice: productPrices[index],
          points: productPoints[index],
          create: 'box',
          gift: productNames[index]
        }
      };
    })
  };
  
var giftingModal = document.getElementById("GiftingModal");
  if (giftingModal) {
setTimeout(function(){
    giftingModal.style.opacity = "1";
giftingModal.style.display = "flex";
},3000)
  }

          }else if(cartCount === 0){
            var requestBody = { items: [{ id: masterSelect.value, quantity, properties:{"customprice":customPrice,"points":pointsAqu,'poi_code': poicode,'shippingrate': 600} }] };
          }else{
            var requestBody = { items: [{ id: masterSelect.value, quantity, properties:{"customprice":customPrice,"points":pointsAqu,'poi_code': poicode} }] };
          }
        }
        
      }else{
        if(pointsAqu != undefined){
                    if (productIds.length > 2) {
alert('AA')
          }else if(cartCount === 0){
            var requestBody = { items: [{ id: masterSelect.value, quantity, properties: {"points":pointsAqu,'poi_code': poicode, 'shippingrate': 600} }] };
          }else{
            var requestBody = { items: [{ id: masterSelect.value, quantity, properties: {"points":pointsAqu,'poi_code': poicode} }] };
          }
        }else{
                    if (productIds.length > 2) {
alert('BB')
          }else if(cartCount === 0){
            var requestBody = { items: [{ id: masterSelect.value, quantity,'poi_code': poicode, 'shippingrate': 600 }] };
          }else{
            var requestBody = { items: [{ id: masterSelect.value, quantity,'poi_code': poicode }] };
          }
        }
      }

      if(shippingrate != '' && shippingrate != undefined){




  var requestBody = {
    items: productIds.map(function (productId, index) {
      return {
        id: productId,
        quantity,
        properties: {
          giftset: datehourandminuteandseconds,
          poi_code :poicode,
          actualprice : productActuals[index],
          customprice: productPrices[index],
          points: productPoints[index],
          create: 'box',
          gift: index === 0 ? "other" : productNames[index]
        }
      };
    })
  };

var giftingModal = document.getElementById("GiftingModal");
  if (giftingModal) {
setTimeout(function(){
    giftingModal.style.opacity = "1";
giftingModal.style.display = "flex";
},3000)
  }

         addToCart(requestBody, () => {
          var submitButton = this.submitButton;
          $('.cart-added:eq(0) .cart-added__title').html(this.submitButton.dataset.productTitle);
          $('.cart-added:eq(0) .inner p .earn a').html("Earn More").css('display', 'none');
          $('.cart-added:eq(0) .cart-added__title+span+span').html("or").css('display', 'none');
          $('.cart-added:eq(0) .cart-added__title+span+span+span').html('<a href="/account/register">Sign Up</a>').css('text-decoration','underline').css('display', 'none');
        submitButton.disabled = false  
        //$('.cart-added:eq(0) .cart-added__title+span').html('aAdded to your cart').css('display', 'block');
          //$('.cart-added:eq(0)').addClass('is-open');
            //setTimeout(function(){
              //submitButton.disabled = false
              //$('.cart-added:eq(0)').removeClass('is-open');
            //},5000)
        // if(this.cartAdded) this.cartAdded.open(this.submitButton.dataset.productTitle);
      });

        
      }

     

      addToCart(requestBody, () => {
          var submitButton = this.submitButton;
          $('.cart-added:eq(0) .cart-added__title').html(this.submitButton.dataset.productTitle);
          $('.cart-added:eq(0) .inner p .earn a').html("Earn More").css('display', 'none');
          $('.cart-added:eq(0) .cart-added__title+span+span').html("or").css('display', 'none');
          $('.cart-added:eq(0) .cart-added__title+span+span+span').html('<a href="/account/register">Sign Up</a>').css('text-decoration','underline').css('display', 'none');
        submitButton.disabled = false  
        //$('.cart-added:eq(0) .cart-added__title+span').html('Added to your cart').css('display', 'block');
          //$('.cart-added:eq(0)').addClass('is-open');
            //setTimeout(function(){
              //submitButton.disabled = false
              //$('.cart-added:eq(0)').removeClass('is-open');
            //},5000)
        // if(this.cartAdded) this.cartAdded.open(this.submitButton.dataset.productTitle);
      });
 
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    initVariants() {
      const variantDropdowns = this.querySelectorAll('variant-dropdown');

      variantDropdowns.forEach(dropdown => {
        this.setVariant(dropdown.getAttribute('data-option-id'), dropdown.getAttribute('data-value'));
      });
    }

    changeButtonToNotify() {
      this.submitButton.setAttribute('data-action', 'notify');
      this.submitButton.innerHTML = `${this.buttonPrice.getAttribute('data-notify-text')}`;
    }

    changeButtonToSubmit() {
      this.submitButton.setAttribute('data-action', 'submit');
      // this.submitButton.innerHTML = `${this.buttonPrice.getAttribute('data-available-text')}${this.currentOption.getAttribute('data-js-price')}`;
      this.submitButton.innerHTML = `${this.buttonPrice.getAttribute('data-available-text')}`;
    }

    updateButton() {
      if(!this.currentOption || !this.submitButton) return;

      const available = this.currentOption.getAttribute('data-js-available') == 'true' ? true : false;
      if(!available) return this.changeButtonToNotify();

      this.changeButtonToSubmit();
    }

    updateActiveVariant() {
      this.masterInput = this.querySelector('.js-master-input');
      if(!this.masterInput) return;

      this.currentOption = this.masterInput.querySelector('option[selected]');
      let selector = 'option';
      
      for (const key in this.variantOptions) {
        selector += `[data-js-option-${key}="${this.variantOptions[key]}"]`;
      }

      const newOption = this.querySelector(selector);
      if(!this.currentOption) this.currentOption = newOption;

      if(!newOption) return;
      if(newOption.getAttribute('value') == this.currentOption.getAttribute('value')) return;
      
      this.currentOption.removeAttribute('selected');
      newOption.setAttribute('selected', '');
      this.currentOption = newOption;
     
      this.masterInput.selectedIndex = newOption.getAttribute('data-js-option-index');
      this.modal = this.closest('modal-dialog');
      if(!this.modal) this.productImages = document.querySelector('.product-main product-images');
      if(this.modal) this.productImages = this.modal.querySelector('product-images');

      this.productImages.slider.selectCell(`[data-variant-id="${this.currentOption.getAttribute('value')}"]`);
     
      this.updateButton();
    }

    setVariant(optionId, value) {
      this.variantOptions[optionId] = value;

      this.updateActiveVariant();
    }

    notifyHandler(event) {
      event.preventDefault();

      const klaviyoButton = this.querySelector('.klaviyo-bis-trigger');
      if(!klaviyoButton) return;

      klaviyoButton.click();
    }

    replaceWishlistLink() {
      let isChanged = false;
      const placeholder = this.querySelector('.js-wishlist');
      if(!placeholder) return;

      const url = placeholder.getAttribute("data-url");
      
      if(!url) return;

      const observer = new MutationObserver(() => {
        if(isChanged) return;

        const link = placeholder.parentElement.querySelector('.wk-link');
        if(!link) return;

        link.setAttribute('href', url);
        isChanged = true;
      });
    
      observer.observe(placeholder, { childList: true, subtree: true });
    }

    connectedCallback() {
      this.replaceWishlistLink();
      
      if(!this.submitButton) return;

      this.submitButton.addEventListener('click', (event) => {
        event.preventDefault();
        
        const action = this.submitButton.getAttribute('data-action');

        if(action == 'submit') return this.onSubmitHandler(event);
        if(action == 'notify') return this.notifyHandler(event);
      });

      this.initVariants();
    }
  });
}


function addToCartAndUpdateUI(productId) {
  var requestBody = { 
    items: [
      { 
        id: productId,  // Replace with your dummy product ID
        quantity: 1,           // Replace with your desired quantity
        properties: {
          "customprice": 0  // Replace with your desired shipping rate
        } 
      }
    ] 
  };

  addToCart(requestBody, () => {
  //  $('.cart-added:eq(0) .cart-added__title').html('You received a free Gift for your purchase');
  // $('.cart-added:eq(0) .cart-added__title+span').html('').css('display', 'block');
//    $('.cart-added:eq(0) .inner p .earn a').html("Earn More").css('display', 'none');
 //   $('.cart-added:eq(0) .cart-added__title+span+span').html("or").css('display', 'none');
//    $('.cart-added:eq(0) .cart-added__title+span+span+span').html('<a href="/account/register"></a>').css('text-decoration','underline').css('display', 'none');
 //    $('.cart-added:eq(0)').addClass('is-open');
 //           setTimeout(function(){
 //             $('.cart-added:eq(0)').removeClass('is-open');
  //          },5000)

setTimeout(function() {
 //   location.reload();
}, 5000);

    // Uncomment the following lines if you want to show/hide elements after a delay
    // $('.cart-added:eq(0) .cart-added__title+span').html('Added to your cart').css('display', 'block');
    // $('.cart-added:eq(0)').addClass('is-open');
    
    // setTimeout(function(){
    //   submitButton.disabled = false
    //   $('.cart-added:eq(0)').removeClass('is-open');
    // }, 5000)

    // If you have a 'cartAdded' object, you can open it with the product title
    // if(this.cartAdded) this.cartAdded.open(this.submitButton.dataset.productTitle);
  });
}


 //setTimeout(function(){
 //     location.reload();
// },2000)  


function addToCartsale(productId) {
  var requestBody = { 
    items: [
      { 
        id: productId,  // Replace with your dummy product ID
        quantity: 1,           // Replace with your desired quantity
        properties: { // Replace with your desired shipping rate
        } 
      }
    ] 
  };

  addToCart(requestBody, () => {
  //  $('.cart-added:eq(0) .cart-added__title').html('You received a free Gift for your purchase');
  // $('.cart-added:eq(0) .cart-added__title+span').html('').css('display', 'block');
//    $('.cart-added:eq(0) .inner p .earn a').html("Earn More").css('display', 'none');
 //   $('.cart-added:eq(0) .cart-added__title+span+span').html("or").css('display', 'none');
//    $('.cart-added:eq(0) .cart-added__title+span+span+span').html('<a href="/account/register"></a>').css('text-decoration','underline').css('display', 'none');
 //    $('.cart-added:eq(0)').addClass('is-open');
 //           setTimeout(function(){
 //             $('.cart-added:eq(0)').removeClass('is-open');
  //          },5000)

setTimeout(function() {
 //   location.reload();
}, 5000);

    // Uncomment the following lines if you want to show/hide elements after a delay
    // $('.cart-added:eq(0) .cart-added__title+span').html('Added to your cart').css('display', 'block');
    // $('.cart-added:eq(0)').addClass('is-open');
    
    // setTimeout(function(){
    //   submitButton.disabled = false
    //   $('.cart-added:eq(0)').removeClass('is-open');
    // }, 5000)

    // If you have a 'cartAdded' object, you can open it with the product title
    // if(this.cartAdded) this.cartAdded.open(this.submitButton.dataset.productTitle);
  });
}

function addToCartredeem(productId) {

  var requestBody = { 
    items: [
      { 
        id: productId,  // Replace with your dummy product ID
        quantity: 1,           // Replace with your desired quantity
        properties: { // Replace with your desired shipping rate
       'product_type': 'Redeem','redeem_points':30,'poi_code':546
        } 
      }
    ] 
  };

  addToCart(requestBody, () => {
  //  $('.cart-added:eq(0) .cart-added__title').html('You received a free Gift for your purchase');
  // $('.cart-added:eq(0) .cart-added__title+span').html('').css('display', 'block');
//    $('.cart-added:eq(0) .inner p .earn a').html("Earn More").css('display', 'none');
 //   $('.cart-added:eq(0) .cart-added__title+span+span').html("or").css('display', 'none');
//    $('.cart-added:eq(0) .cart-added__title+span+span+span').html('<a href="/account/register"></a>').css('text-decoration','underline').css('display', 'none');
 //    $('.cart-added:eq(0)').addClass('is-open');
 //           setTimeout(function(){
 //             $('.cart-added:eq(0)').removeClass('is-open');
  //          },5000)

setTimeout(function() {
 //   location.reload();
}, 5000);

    // Uncomment the following lines if you want to show/hide elements after a delay
    // $('.cart-added:eq(0) .cart-added__title+span').html('Added to your cart').css('display', 'block');
    // $('.cart-added:eq(0)').addClass('is-open');
    
    // setTimeout(function(){
    //   submitButton.disabled = false
    //   $('.cart-added:eq(0)').removeClass('is-open');
    // }, 5000)

    // If you have a 'cartAdded' object, you can open it with the product title
    // if(this.cartAdded) this.cartAdded.open(this.submitButton.dataset.productTitle);
  });
}